import { feedPostContentTypeFilterOptions } from '../support/openDiscussions/config/postComposeConstants';
import { FiMessageSquare, FiUser } from 'react-icons/fi';

export const SEARCH_TAB_ALL = 'all';
export const SEARCH_TAB_PEOPLE = 'people';
export const SEARCH_TAB_MESSAGES = 'messages';

const POST_TYPE_TABS = feedPostContentTypeFilterOptions().map((opt) => ({
  id: opt.value,
  label: opt.label,
  postType: opt.value,
  icon: opt.icon,
  iconTone: opt.iconTone,
}));

export const SEARCH_TABS = [
  { id: SEARCH_TAB_ALL, label: 'All' },
  ...POST_TYPE_TABS,
  { id: SEARCH_TAB_PEOPLE, label: 'People', icon: <FiUser aria-hidden /> },
  { id: SEARCH_TAB_MESSAGES, label: 'Messages', icon: <FiMessageSquare aria-hidden /> },
];

export function normalizeSearchTab(tab) {
  const id = String(tab || '').trim().toLowerCase();
  return SEARCH_TABS.some((t) => t.id === id) ? id : SEARCH_TAB_ALL;
}

export function searchTabShowsPosts(tab) {
  const id = normalizeSearchTab(tab);
  return id !== SEARCH_TAB_PEOPLE && id !== SEARCH_TAB_MESSAGES;
}

export function searchTabShowsDiscoverablePeople(tab) {
  const id = normalizeSearchTab(tab);
  return id === SEARCH_TAB_ALL || id === SEARCH_TAB_PEOPLE;
}

/** People open to new messages (chat_visibility: public). */
export function searchTabShowsMessageablePeople(tab) {
  return normalizeSearchTab(tab) === SEARCH_TAB_MESSAGES;
}

export function searchTabShowsPeopleSearch(tab) {
  return searchTabShowsDiscoverablePeople(tab) || searchTabShowsMessageablePeople(tab);
}

/** @deprecated Use searchTabShowsDiscoverablePeople */
export function searchTabShowsPeople(tab) {
  return searchTabShowsDiscoverablePeople(tab);
}

export function searchTabShowsMessages(tab) {
  return normalizeSearchTab(tab) === SEARCH_TAB_MESSAGES;
}

export function postContentTypesForSearchTab(tab) {
  const id = normalizeSearchTab(tab);
  if (id === SEARCH_TAB_ALL || id === SEARCH_TAB_PEOPLE || id === SEARCH_TAB_MESSAGES) return undefined;
  return [id];
}
